import React from 'react';
import { motion } from 'framer-motion';

const TERMS_LAST_UPDATED = "March 17, 2025";

const TermsAndConditionsPage: React.FC = () => {
  return (
    <div className="py-16 bg-background">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <motion.h1 
            className="text-4xl font-extrabold text-text tracking-tight sm:text-5xl"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Terms and Conditions
          </motion.h1>
          <motion.p 
            className="mt-4 text-xl text-text"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Last updated: {TERMS_LAST_UPDATED}
          </motion.p>
        </div>

        <motion.div
          className="prose prose-lg mx-auto text-text"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <p>
            Please read these Terms of Use ("Terms", "Terms of Use") carefully before using the https://reasonshield.ai website (the "Service") operated by ReasonShield ("us", "we", or "our").
          </p>
          
          <p>
            Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.
          </p>
          
          <p>
            By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.
          </p>
          
          <h2 className="text-2xl font-bold mt-8 mb-4">Intellectual Property</h2>
          <p>
            The Service and its original content, features and functionality are and will remain the exclusive property of ReasonShield and its licensors.
          </p>
          
          <h2 className="text-2xl font-bold mt-8 mb-4">Links To Other Web Sites</h2>
          <p>
            Our Service may contain links to third-party web sites or services that are not owned or controlled by ReasonShield.
          </p>
          
          <p>
            ReasonShield has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that ReasonShield shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.
          </p>
          
          <p>
            We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that you visit.
          </p>
          
          <h2 className="text-2xl font-bold mt-8 mb-4">Termination</h2>
          <p>
            We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
          
          <p>
            All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.
          </p>
          
          <h2 className="text-2xl font-bold mt-8 mb-4">Disclaimer</h2>
          <p>
            Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.
          </p>
          
          <h2 className="text-2xl font-bold mt-8 mb-4">Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the laws of United States without regard to its conflict of law provisions.
          </p>
          
          <p>
            Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.
          </p>
          
          <h2 className="text-2xl font-bold mt-8 mb-4">Changes</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
          </p>
          
          <p>
            By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.
          </p>
          
          <h2 className="text-2xl font-bold mt-8 mb-4">Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage; 